var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9594 7.04474L14.9251 2.86038C15.1209 2.01171 16.1738 1.70974 16.7897 2.3256L21.6744 7.21015C22.2903 7.82602 21.9883 8.87894 21.1396 9.07479L16.9552 10.0404C17.2798 11.2149 17.1376 12.5405 16.5466 13.7439L11.8683 6.93919C12.5807 6.82686 13.2943 6.86095 13.9594 7.04474Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6478 15.0842C15.5606 15.1831 15.4697 15.28 15.375 15.3747C14.7418 16.0079 14.0107 16.472 13.2469 16.7625L8.07988 9.24688C8.24491 9.03132 8.42667 8.82335 8.62504 8.62499C9.15026 8.09979 9.74282 7.69095 10.3655 7.40097L15.6478 15.0842Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25801 10.6991L11.6675 17.113C11.1114 17.151 10.5612 17.0989 10.0406 16.955L9.07493 21.1396C8.87908 21.9883 7.82618 22.2903 7.2103 21.6744L2.32562 16.7899C1.70973 16.174 2.0117 15.1211 2.86039 14.9252L7.04484 13.9596C6.75957 12.9277 6.83474 11.779 7.25801 10.6991Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyAlt);
export default __webpack_public_path__ + "static/media/candy-alt.b37c53a3761eed85f507f293f2d588c4.svg";
export { ForwardRef as ReactComponent };